export const serviceItems = [
  {
    id: 1,
    value: '21-day trial of bravoSuite products'
  },
  {
    id: 2,
    value: "Free consultation on bravoSUITE's features"
  },
  {
    id: 3,
    value: 'Our team to reach out to you'
  },
  {
    id: 4,
    value: 'Free Job Posting'
  },
  {
    id: 5,
    value: 'Others'
  }
];
